export default "__VITE_ASSET__hCq_0aFX__"